import { ContactContainer } from '../containers/contact'

export default function Contact() {
  return <ContactContainer />
}